import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import React, { useState } from "react";
import SharedPreferences from "../../core/utils/SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";
import { ROUTE_ENDPOINTS } from "../../data/constant/RouteConstants";
import { HomeView } from "../pages/home/HomeView";
import { LandingView } from "../pages/landing/LandingView";
import { GameView } from "../pages/game/GameView";
import { GameFinishedView } from "../pages/game/finishedView/GameFinishedView";
import { alpha, Backdrop, Box, CircularProgress, Stack } from "@mui/material";
import { COLOR_BLACK, COLOR_WHITE } from "../../data/colors/Colors";
import { CustomTextView } from "../component/CustomTextView";
import { useTranslation } from "react-i18next";

export default function Router() {
  const getShowLoading = () =>
    SharedPreferences.getBoolean(STORAGE_KEYS.SHOW_LOADING) == true;
  const getLoginToken = () =>
    SharedPreferences.getString(STORAGE_KEYS.TOKEN) !== null;

  const [isLoggedIn, setIsLoggedIn] = useState(getLoginToken());

  const [showLoading, setShowLoading] = useState(getShowLoading());

  window.addEventListener(STORAGE_KEYS.TOKEN, () => {
    setIsLoggedIn(getLoginToken());
  });

  window.addEventListener(STORAGE_KEYS.SHOW_LOADING, () => {
    setShowLoading(getShowLoading());
  });

  function PublicRoute(path: string, element: React.ReactNode) {
    return (
      <Route
        path={path}
        element={
          isLoggedIn ? <Navigate to={ROUTE_ENDPOINTS.HOME_PLAY} /> : element
        }
      />
    );
  }

  function AuthRoute(path: string, element: React.ReactNode) {
    return (
      <Route
        path={path}
        element={
          isLoggedIn ? element : <Navigate to={ROUTE_ENDPOINTS.LANDING} />
        }
      />
    );
  }

  const { t } = useTranslation();

  return (
    <Box>
      <Backdrop
        open={showLoading}
        sx={{
          bgcolor: alpha(COLOR_BLACK, 0.8),
          zIndex: (theme) => theme.zIndex.drawer + 999,
        }}
      >
        <Stack alignItems={"center"} gap={2}>
          <CircularProgress sx={{ color: COLOR_WHITE }} size={40} />
          <CustomTextView
            text={t("loading")}
            textColor={COLOR_WHITE}
            variant="h6"
            fontWeight="bold"
          />
        </Stack>
      </Backdrop>
      <BrowserRouter>
        <Routes>
          {PublicRoute(ROUTE_ENDPOINTS.LANDING, <LandingView />)}
          {AuthRoute(ROUTE_ENDPOINTS.HOME, <HomeView />)}
          {AuthRoute(ROUTE_ENDPOINTS.GAME, <GameView />)}
          {AuthRoute(ROUTE_ENDPOINTS.GAME_FINISHED, <GameFinishedView />)}
          <Route path="*" element={<Navigate to={ROUTE_ENDPOINTS.LANDING} />} />
        </Routes>
      </BrowserRouter>
    </Box>
  );
}
